// نظام الإشعارات الدستوري - toast منزلق بهوية الثيم
let host;
function ensureHost() {
  if (host && document.body.contains(host)) return host;
  host = document.createElement("div");
  host.style.cssText = "position:fixed;bottom:22px;left:22px;z-index:99999;display:flex;flex-direction:column;gap:10px;direction:rtl;pointer-events:none;";
  document.body.appendChild(host);
  return host;
}
export function toast(msg, type = "ok") {
  try {
    const h = ensureHost();
    const el = document.createElement("div");
    const color = type === "err" ? "#e23d3d" : type === "ok" ? "#0e9f6e" : (getComputedStyle(document.documentElement).getPropertyValue("--accent").trim() || "#14b8a6");
    el.textContent = String(msg);
    el.style.cssText = "font-family:'Tajawal','Cairo',sans-serif;font-size:14px;font-weight:700;line-height:1.6;color:var(--text,#0b1220);background:var(--surface,#fff);border:1.5px solid " + color + ";box-shadow:4px 4px 0 " + color + "55;border-radius:0;padding:12px 18px;max-width:360px;pointer-events:auto;cursor:pointer;opacity:0;transform:translateX(-16px);transition:all .3s cubic-bezier(.34,1.56,.64,1);";
    el.onclick = () => { el.style.opacity = "0"; el.style.transform = "translateX(-16px)"; setTimeout(() => el.remove(), 300); };
    h.appendChild(el);
    requestAnimationFrame(() => { el.style.opacity = "1"; el.style.transform = "none"; });
    setTimeout(() => { if (!el.parentNode) return; el.style.opacity = "0"; el.style.transform = "translateX(-16px)"; setTimeout(() => el.remove(), 320); }, 3500);
  } catch (e) { try { alert(String(msg)); } catch {} }
}
if (typeof window !== "undefined") window.toast = toast;
